import axios from "axios";
import { Base_URL } from "../url";

// Main API call to save purchase order
export const savePurchaseOrder = async (orderData, userName = "5") => {
  try {
    // Build items array from orderData.items (filter out empty rows)
    const itemsPayload = (orderData.items || [])
      .filter((it) => it && (it.item || it.quantity)) // drop empty rows
      .map((it) => ({
        Item_code: it.item ?? "",
        Quantity: it.quantity != null ? String(it.quantity) : "",
        Unit_Code: it.unit ?? "",
        Price: it.price != null ? String(it.price) : "",
        itemDetails: it.itemDetails ?? "",
        Requested_Delivery_Date: it.requestedDeliveryDate ?? null,
        Requested_For: it.purchaseRequestedFor ?? "",
        Requested_For_Code: it.purchaseRequestedForCode ?? "",
        Office_Code: it.officeOfSupply ?? "",
        Store_Code: it.storeOfSupply ?? "",
        igst:it.igst,
        cgst:it.cgst,
        sgst:it.sgst,
        igstAmount:it.igstAmount,
        cgstAmount:it.cgstAmount,
        sgstAmount:it.sgstAmount,
      }));

    const apiData = {
      pO_type: orderData.poType,
      merchantCode: orderData.merchantCode,
      pO_Date: orderData.poDate,           // keep as ISO/date string from the form
      currencyCode: orderData.currency,    // moved to header
      // Optional header fields you may want to include:
      // officeOfSupply: orderData.officeOfSupply,
      // storeOfSupply: orderData.storeOfSupply,
      Items: itemsPayload
    };

    const url = `${Base_URL}/PurchaseOrder/CreatePurchaseOrder?UserName=${encodeURIComponent(
      userName
    )}`;

    const response = await axios.post(url, apiData);
    return response.data;
  } catch (error) {
    // bubble up server message if available
    throw error.response?.data || error.message || "Error saving purchase order!";
  }
};

// API calls for dropdown options
export const getPOTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/PRType/GetAllPRTypes`);
    return response.data
    
  } catch (error) {
    throw error.response?.data || "Error fetching PO types!";
  }
};

export const getMerchants = async () => {
  try {
    const response = await axios.get(`${Base_URL}/MerchantMaster/GetAllMerchants`);
    return response.data.map(item => ({
      value: item.merchantCode,
      label: `${item.merchantCode} - ${item.merchantName}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching merchants!";
  }
};

export const getItemTypes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ItemTypeMaster/GetAllItemTypes`);
    return response.data.map(item => ({
      value: item.code,
      label: `${item.code} - ${item.description}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching item types!";
  }
};

export const getItems = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Item/ItemGetData`);
    return response.data.map(item => ({
      value: item.itemCode,
      label: `${item.itemCode} - ${item.itemName}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching items!";
  }
};

export const getUnits = async () => {
  try {
    const response = await axios.get(`${Base_URL}/UnitMaster/GetAllUnits`);
    return response.data.map(item => ({
      value: item.code,
      label: `${item.code} - ${item.description}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching units!";
  }
};

export const getOffices = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Office/OfficeGetData`);
    return response.data.map(item => ({
      value: item.officeCode,
      label: `${item.officeCode} - ${item.officeName}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching offices!";
  }
};

export const getStores = async () => {
  try {
    const response = await axios.get(`${Base_URL}/StoreMaster/GetAllStores`);
    return response.data.map(item => ({
      value: item.code,
      label: `${item.code} - ${item.name}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching stores!";
  }
};

export const getRequestedForOptions = async (type,id) => {
  try {

    if (type === "Project") {
      const response = await axios.get(
        `${Base_URL}/ProjectMaster/GetProjectsByOrg/${id}`
      );

      return response.data.map(item => ({
        value: item.projectId,
        label: `${item.prTitle} - ${item.projectId}`
      }));
    }
    
    const response = await axios.post(`${Base_URL}/SalaryProcess/MasterData/${id}?type=${type}`);
    
    switch (type) {
      case "Resource":
        return response.data.map(item => ({
          value: item.resourceId,
          label: `${item.resourceId} - ${item.name}`
        }));
      case "Department":
        return response.data.map(item => ({
          value: item.code,
          label: `${item.code} - ${item.description}`
        }));
      case "Cost Center":
        return response.data.map(item => ({
          value: item.costCenterCode,
          label: `${item.costCenterCode} - ${item.costCenterName}`
        }));
      case "Cost Center Group":
        return response.data.map(item => ({
          value: item.groupCode,
          label: `${item.groupCode} - ${item.groupName}`
        }));
      case "Office":
        return response.data.map(item => ({
          value: item.officeCode,
          label: `${item.officeCode} - ${item.officeName}`
        }));
      case "Company":
        return response.data.map(item => ({
          value: item.companyCode,
          label: `${item.companyCode} - ${item.name}`
        }));
          case "Inventory":
        return response.data.map(item => ({
          value: item.officeCode,
          label: `${item.officeCode} - ${item.officeName}`
        }));
      default:
        return [];
    }
  } catch (error) {
    throw error.response?.data || "Error fetching requested for options!";
  }
};

// Currency options (assuming these are static)
export const getCurrencies = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CurrencyMaster/GetAllCurrencies`);
    return response.data.map(item => ({
      value: item.currencyCode,
      label: `${item.currencyCode} - ${item.currencyName}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching stores!";
  }
};

export const GetMovementType=async(id)=>{
  try{
    const response=await axios.get(`${Base_URL}/MovementType/id?id=${id}`)
    return response.data;
  }
  catch (error) {
    throw error.response?.data || "Error fetching Movement Type!";
  }
}
